<template>
  <div class="col-12">
    <div class=" mt-4">
      <section-title title="Información de seguimiento" :has-line="true" />
    </div>

    <div class="header thead-property d-flex align-items-center p-3">
      <div class="col-4 pt-0">
        <span>Fecha</span>
      </div>
      <div class="col-4 pt-0">
        <span>Comentario</span>
      </div>
      <div class="col-4 pt-0">
        <span />
      </div>
    </div>

    <div
      v-if="
        trackingInfoItems.length == 0 &&
          !isCreatingTrackingItems &&
          !isEditingTrackingItems
      "
      class=""
    >
      <div class="mb-4 p-4 info-seguimiento">
        <div class="col-12 text-center">
          <button
            id="btnFA"
            class="btn bg-light-white w-75 pt-1"
            @click="isCreatingTrackingItems = !isCreatingTrackingItems"
          >
            <i class="fas fa-file-plus pr-4 text-green" />
            <span class="text-button-add-document">
              Presione aqu&iacute; para a&ntilde;adir documento de respaldo
            </span>
          </button>
        </div>
      </div>
    </div>

    <div
      v-if="
        trackingInfoItems.length > 0 &&
          !isCreatingTrackingItems &&
          !isEditingTrackingItems
      "
      class=""
    >
      <div
        v-for="item in trackingInfoItems"
        :key="item.id"
        class="d-flex align-items-center p-4"
      >
        <div class="col-4 pt-0">
          <span>{{ formatDate(item.date) }}</span>
        </div>
        <div class="col-5 pt-0">
          <span>{{ item.comment }}</span>
        </div>
        <div class="col-3 pt-0 text-right">
          <span>
            <div class="dropdown">
              <button
                id="ddTrackingInfo"
                class="btn btn-dropdown-actions dropdown-toggle pt-1"
                type="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                Acciones
              </button>
              <div class="dropdown-menu" aria-labelledby="ddTrackingInfo">
                <div class="dropdown-item" @click="editTrackingInfo(item)">
                  <em class="fa fa-pencil text-green pr-1" />
                  <span>Editar</span>
                </div>
              </div>
            </div>
          </span>
        </div>
      </div>
    </div>

    <div
      v-if="!isCreatingTrackingItems && !isEditingTrackingItems"
      class="col-12 text-right pr-0"
    >
      <ActionButton
        variant="success m-2 pl-4 pr-4"
        type="submit"
        i="fas fa-file-plus"
        @click="isCreatingTrackingItems = !isCreatingTrackingItems"
      >
        Añadir
      </ActionButton>
    </div>

    <!--EDITING ITEM-->
    <div v-if="editingItem != {} && isEditingTrackingItems" class="col-12">
      <validation-observer ref="editingTrackingItemForm">
        <form novalidate @submit.prevent="saveTrackingItem">
          <CustomCollapse id="serviceDocumentAdd" class="mt-0">
            <CustomCollapseItem
              parent-id="serviceDocumentAdd"
              title="Añadir Documento"
              :selected="true"
              expanded
            >
              <div class="col-12 d-flex justify-content-left">
                <div class="col-md-3">
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="Fecha"
                    :rules="`${isEditingTrackingItems ? 'required' : ''}`"
                  >
                    <custom-date-picker
                      v-model="editingItem.date"
                      label="Fecha: "
                      format="dd/MMM./yyyy"
                      required
                      :error="errors[0]"
                      :custom-error-msg.sync="errors[0]"
                    />
                  </ValidationProvider>
                </div>
              </div>
              <div class="col-12 m-3 mt-4">
                <ValidationProvider
                  v-slot="{ errors }"
                  class="w-100"
                  name="Comentario"
                  :rules="`${isEditingTrackingItems ? 'required' : ''}`"
                >
                  <CustomTextArea
                    id="trackingItemComment"
                    v-model="editingItem.comment"
                    class="w-100"
                    label="Añadir Comentario"
                    :maxlength="500"
                    placeholder="Escribir aqui"
                    required
                    :error="errors[0]"
                    :custom-error-msg.sync="errors[0]"
                  />
                </ValidationProvider>
              </div>
              <div class="row">
                <div class="col text-right">
                  <ActionButton
                    i="fas fa-times-circle"
                    variant="outline-danger btn-cancel danger m-2"
                    @click="clearTrackingItem"
                  >
                    Cancelar
                  </ActionButton>
                  <ActionButton variant="success m-2 pl-4 pr-4" type="submit">
                    Añadir
                  </ActionButton>
                </div>
              </div>
            </CustomCollapseItem>
          </CustomCollapse>
        </form>
      </validation-observer>
    </div>

    <div v-if="isCreatingTrackingItems" class="col-12">
      <validation-observer ref="trackingItemForm">
        <form novalidate @submit.prevent="saveTrackingItem">
          <CustomCollapse id="serviceDocumentAdd" class="mt-0">
            <CustomCollapseItem
              parent-id="serviceDocumentAdd"
              title="Añadir Documento"
              :selected="true"
              expanded
            >
              <div class="col-12 d-flex justify-content-left">
                <div class="col-md-3">
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="Fecha"
                    :rules="`${isCreatingTrackingItems ? 'required' : ''}`"
                  >
                    <custom-date-picker
                      v-model="trackingItemDate"
                      label="Fecha: "
                      format="dd/MMM./yyyy"
                      required
                      :error="errors[0]"
                      :custom-error-msg.sync="errors[0]"
                    />
                  </ValidationProvider>
                </div>
              </div>
              <div class="col-12 m-3 mt-4">
                <ValidationProvider
                  v-slot="{ errors }"
                  class="w-100"
                  name="Comentario"
                  :rules="`${isCreatingTrackingItems ? 'required' : ''}`"
                >
                  <CustomTextArea
                    id="trackingItemComment"
                    v-model="trackingItemComment"
                    class="w-100"
                    label="Añadir Comentario"
                    :maxlength="500"
                    placeholder="Escribir aqui"
                    required
                    :error="errors[0]"
                    :custom-error-msg.sync="errors[0]"
                  />
                </ValidationProvider>
              </div>
              <div class="row">
                <div class="col text-right">
                  <ActionButton
                    i="fas fa-times-circle"
                    variant="outline-danger btn-cancel danger m-2"
                    @click="clearTrackingItem"
                  >
                    Cancelar
                  </ActionButton>
                  <ActionButton variant="success m-2 pl-4 pr-4" type="submit">
                    Añadir
                  </ActionButton>
                </div>
              </div>
            </CustomCollapseItem>
          </CustomCollapse>
        </form>
      </validation-observer>
    </div>

    <validation-observer>
      <form ref="referralDataForm" novalidate @submit.prevent="handleSubmit">
        <div class="">
          <section-title title="Razón de Referido" :has-line="true" />
        </div>
        <div class=" m-3">
          <ValidationProvider
            v-slot="{ errors }"
            class="w-100"
            name="razón de referido"
            rules="required"
          >
            <CustomTextArea
              id="referralReason"
              v-model="referralReason"
              class="w-100"
              :maxlength="500"
              placeholder="Escribir aqui"
              required
              :error="errors[0]"
              :custom-error-msg.sync="errors[0]"
            />
          </ValidationProvider>
        </div>

        <div class=" mt-4">
          <section-title
            title="Información de Persona Contacto"
            :has-line="true"
          />
        </div>

        <div class=" d-flex justify-item-between pl-2">
          <div class="col-4 pt-0">
            <ValidationProvider
              v-slot="{ errors }"
              name="nombre"
              rules="required"
            >
              <CustomInput
                v-model="contactName"
                label="Nombre: "
                required
                :error="errors[0]"
                :custom-error-msg.sync="errors[0]"
              />
            </ValidationProvider>
          </div>
          <div class="col-4 pt-0">
            <ValidationProvider
              v-slot="{ errors }"
              name="teléfono"
              rules="required"
            >
              <CustomInput
                v-model="contactTelephone"
                label="Teléfono: "
                required
                :error="errors[0]"
                :custom-error-msg.sync="errors[0]"
              />
            </ValidationProvider>
          </div>
          <div class="col-4 d-flex pt-0 ">
            <div class="col-1 d-flex align-items-center text-center">
              <input id="defaultCheck1" type="checkbox" />
            </div>
            <div class="col-11 d-flex align-items-center text-center pt-3">
              <span>Desea recibir mensaje de texto</span>
            </div>
          </div>
        </div>

        <div class=" d-flex justify-content-between pl-2">
          <div class="col-4">
            <ValidationProvider
              v-slot="{ errors }"
              name="parentesco"
              rules="required"
            >
              <custom-drop-down
                v-model="selectedRelationship"
                fieldname="name"
                fieldkey="id"
                :options="relationships"
                placeholder="Seleccione"
                label="Parentesco:"
                :error="errors[0]"
                :custom-error-msg.sync="errors[0]"
              />
            </ValidationProvider>
          </div>
          <div class="col-4">
            <ValidationProvider
              v-slot="{ errors }"
              name="email"
              rules="required"
            >
              <CustomInput
                v-model="contactEmail"
                label="Email: "
                required
                :error="errors[0]"
                :custom-error-msg.sync="errors[0]"
              />
            </ValidationProvider>
          </div>
          <div class="col-4">
            <ValidationProvider
              v-slot="{ errors }"
              name="proveedor"
              rules="required"
            >
              <custom-drop-down
                v-model="selectedProvider"
                fieldname="name"
                fieldkey="id"
                placeholder="Seleccione"
                :options="providers"
                label="Proveedor:"
                :error="errors[0]"
                :custom-error-msg.sync="errors[0]"
              />
            </ValidationProvider>
          </div>
        </div>
      </form>

      <div class=" mt-4">
        <section-title
          title="Información de Evaluación Inicial"
          :has-line="true"
        />
      </div>

      <div class=" d-flex justify-content-between py-2">
        <div class="col-8 d-flex align-content-center">
          <span>
            ¿Este estudiante cuenta con una evaluación vigente, previa, provista
            al momento de registro?
          </span>
        </div>
        <div class="col-4 text-right pt-0">
          <ValidationProvider
            v-slot="{ errors }"
            class="w-100"
            name="Evaluacion previa valida"
            rules="required"
          >
            <CustomRadioGroup
              v-model="previousValidEvaluation"
              name="validEvaluation"
              :options="radioButtonsOptions"
              :error="errors[0]"
              :custom-error-msg.sync="errors[0]"
              :is-inline="true"
              :is-disabled="false"
            />
          </ValidationProvider>
        </div>
      </div>
      <div class="d-flex justify-content-between py-2">
        <div class="col-8">
          <span>
            ¿El estudiante tiene problemas de transportación para la cita de
            evaluación inicial?
          </span>
        </div>
        <div class="col-4 text-right pt-0">
          <ValidationProvider
            v-slot="{ errors }"
            class="w-100"
            name="Problemas de transporte"
            rules="required"
          >
            <CustomRadioGroup
              v-model="transportProblems"
              name="transportProblem"
              :options="radioButtonsOptions"
              :error="errors[0]"
              :custom-error-msg.sync="errors[0]"
              :is-inline="true"
              :is-disabled="false"
            />
          </ValidationProvider>
        </div>
      </div>

      <div class=" mt-4">
        <div class="col-12 pl-3">
          <ValidationProvider
            v-slot="{ errors }"
            class="w-100"
            name="como solucionó el problema"
            rules="required"
          >
            <CustomTextArea
              id="problemSolution"
              v-model="problemSolution"
              class="w-100"
              label="¿Cómo se solucionó el problema?"
              :maxlength="500"
              placeholder="Escribir aqui"
              required
              :error="errors[0]"
              :custom-error-msg.sync="errors[0]"
            />
          </ValidationProvider>
        </div>
      </div>
    </validation-observer>
  </div>
</template>

<script>
import SectionTitle from '@/components/common/page/SectionTitle.vue';
import CustomTextArea from '@/components/common/CustomTextArea';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import CustomInput from '@/components/common/CustomInput';
import CustomDropDown from '@/components/common/CustomDropDown';
import CustomRadioGroup from '@/components/common/CustomRadio';
import CustomCollapse from '@/components/common/CustomCollapse';
import CustomCollapseItem from '@/components/common/CustomCollapseItem';
import CustomDatePicker from '@/components/common/CustomDatePicker';
import { ActionButton } from '@/components/common';
import moment from 'moment';

export default {
  name: 'ReferralDataTab',
  data() {
    return {
      isCreatingTrackingItems: false,
      isEditingTrackingItems: false,

      providers: [{ id: 0, name: 'Arecibo' }],
      relationships: [{ id: 1, name: 'Papa' }],
      trackingInfoItems: [],
      editingItem: {},

      selectedRelationship: null,
      selectedProvider: null,
      contactEmail: null,
      referralReason: null,
      problemSolution: null,
      previousValidEvaluation: null,
      transportProblems: null,
      trackingItemComment: null,
      trackingItemDate: null,
      contactTelephone: null,
      contactName: null,

      radioButtonsOptions: [
        { label: 'Si', value: 'true' },
        { label: 'No', value: 'false' },
      ],
    };
  },

  components: {
    SectionTitle,
    CustomTextArea,
    ValidationProvider,
    CustomInput,
    ValidationObserver,
    CustomDropDown,
    CustomRadioGroup,
    CustomCollapse,
    CustomCollapseItem,
    ActionButton,
    CustomDatePicker,
  },
  methods: {
    async handleSubmit() {},
    clearTrackingItem() {
      this.trackingItemDate = null;
      this.trackingItemComment = null;
      this.isCreatingTrackingItems = false;
      this.isEditingTrackingItems = false;
    },
    async saveTrackingItem() {
      if (this.isEditingTrackingItems) {
        const isValidEdit = await this.$refs.editingTrackingItemForm.validate();
        if (isValidEdit) {
          let editedTrackingInfo = {
            id: this.editingItem.id,
            date: this.editingItem.date,
            comment: this.editingItem.comment,
          };
          //TODO: UPDATE TRACKING INFO
          for (let item in this.trackingInfoItems) {
            if (item.id == editedTrackingInfo.id) {
              item.date = editedTrackingInfo.date;
              item.comment = editedTrackingInfo.comment;
            }
          }
        }

        this.clearTrackingItem();
      }
      const isValid = await this.$refs.trackingItemForm.validate();
      if (isValid) {
        let newTrackingInfo = {
          id: this.trackingInfoItems.length,
          date: this.trackingItemDate,
          comment: this.trackingItemComment,
        };
        this.trackingInfoItems.push(newTrackingInfo);
        //GUARDAR TRACKING INFO
        this.clearTrackingItem();
      }
    },
    formatDate(date) {
      return moment(date)
        .locale('es')
        .format('DD/MMM/YYYY');
    },

    async editTrackingInfo(item) {
      this.isEditingTrackingItems = true;
      this.editingItem = item;
    },
  },
};
</script>
<style scoped>
.header {
  font: Bold 16px/22px Lato;
  letter-spacing: 0;
  color: #ffffff;
  opacity: 1;
  background: #3f5b60 0% 0% no-repeat padding-box;
  border-radius: 5px 5px 0px 0px;
  opacity: 1;
}

.info-seguimiento {
  background: #fafbfa 0% 0% no-repeat padding-box;
  opacity: 1;
}

.btn-dropdown-actions {
  text-align: center;
  font-family: 'Lato', sans-serif;
  font-weight: 700;
  font-size: 1rem;
  color: rgb(12, 19, 16);
  border-radius: 4px;
  margin-right: 0px;
  border: 1px solid #2db782;
  width: 7.8125rem;
  height: 2.25rem;
}
</style>
